import type { CalculatorMeta } from '../../types/calculator';

const meta: CalculatorMeta = {
  route: '/subscription-latte-factor',
  component: () => import('../../routes/SubscriptionLatte.svelte'),
  card: {
    id: 'subscription-latte-factor',
    title: 'Subscription & Latte Factor',
    description: 'See how small recurring expenses add up and what they could be worth if invested instead.',
    icon: 'coffee',
    iconBgClass: 'bg-amber-50',
    iconTextClass: 'text-amber-600',
    href: '/subscription-latte-factor',
    category: 'Life & Budget',
  },
  seo: {
    title: 'Subscription & Latte Factor Calculator – Small Expense Wealth Impact',
    description: 'Free subscription and Latte Factor calculator. See how small recurring expenses add up over time and what they could be worth if invested instead. Calculate the long-term wealth impact of daily coffee, streaming services, and other subscriptions.',
  },
};

export default meta;
